import { createNavigationContainerRef, StackActions } from '@react-navigation/native';
import { RootStackParamList } from './types';

export const navigationRef = createNavigationContainerRef<RootStackParamList>();

/** Navigate from anywhere, including surfaces mounted OUTSIDE the navigator.
 *
 * CORE-509 — the celebration screens moved to the app root (a level-up is a
 * platform-wide event, not a profile-page one), which puts them outside
 * `NavigationContainer`. `useNavigation` throws there; the container ref does
 * not. No-ops until the container is ready, exactly like `navigateToLogin`. */
export function navigateTo(name: string, params?: object) {
  if (navigationRef.isReady()) {
    (navigationRef.navigate as unknown as (n: string, p?: object) => void)(name, params);
  }
}

export function navigateToLogin() {
  if (navigationRef.isReady()) {
    navigationRef.reset({
      index: 0,
      routes: [{ name: 'Login' }],
    });
  }
}

/**
 * CORE-2098 — вход ВМЕСТО текущего экрана, как вход из Live (CORE-2091):
 * `replace`, а не `navigate`. Экран под входом не остаётся смонтированным —
 * комната разбирает RTC и хабы тем же путём, что и при уходе со страницы, —
 * а `returnTo` возвращает человека туда же после входа.
 */
export function replaceWithLogin(returnTo?: string) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(StackActions.replace('Login', returnTo ? { returnTo } : undefined));
  }
}
